



 (function () {
  const removeDisabled = () => {
    document.querySelectorAll('[disabled]').forEach(el => {
      el.removeAttribute('disabled');
      el.disabled = false;
    });
  };

  // 1️⃣ Remove on page load / refresh
  document.addEventListener('DOMContentLoaded', removeDisabled);

  // 2️⃣ Remove on any click
  document.addEventListener('click', removeDisabled);

  // 3️⃣ Prevent future additions (Shopify / JS safe)
  const observer = new MutationObserver(removeDisabled);
  observer.observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ['disabled']
  });
})();


  document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('searchInput');
  if (!searchInput) return; // prevents error if element not on page

  searchInput.addEventListener('input', function () {
    const searchVal = this.value.trim().toLowerCase();
    const products = document.querySelectorAll('.custom-main-inner-wrap');

    products.forEach(function (product) {
      const title = (product.getAttribute('data-title') || '').toLowerCase();

      if (searchVal === '' || title.includes(searchVal)) {
        product.style.display = 'block';
      } else {
        product.style.display = 'none';
      }
    });
  });
});


  document.getElementById('searchInput').addEventListener('input', function () {
    var searchVal = this.value.trim();
    var allTabs = document.querySelectorAll('.nav-tabs .tab-btn');
    var allProductsBtn = document.querySelector(".nav-tabs .tab-btn[onclick*='custom-all']");

    if (searchVal.length > 0) {
      // sab tabs hide karo
      allTabs.forEach(function (btn) {
        btn.classList.add('myhidden');
        btn.classList.remove('active-tab');
      });

      // All Products ko dikhana aur activate karna
      allProductsBtn.classList.remove('myhidden');
      allProductsBtn.classList.add('active-tab');

      // uska click trigger bhi karo
      allProductsBtn.click();
    } else {
      // sab tabs wapas show karo
      allTabs.forEach(function (btn, index) {
        btn.classList.remove('myhidden');
        btn.classList.remove('active-tab');
      });

      // pehli tab ko wapas active aur click karo
      let firstTab = allTabs[0];
      firstTab.classList.add('active-tab');
      firstTab.click();

      // All Products tab ko wapas hide karo
      allProductsBtn.classList.add('myhidden');
      allProductsBtn.classList.remove('active-tab');
    }
  });
  document.addEventListener('DOMContentLoaded', function () {

  function initLoadMore(wrapperSelector, buttonSelector, initialVisible = 10, increment = 10) {
    const wrapper = document.querySelector(wrapperSelector);
    if (!wrapper) return;

    const items = wrapper.querySelectorAll('.collection__item');
    const loadMoreBtn = document.querySelector(buttonSelector);
    if (!loadMoreBtn) return;

    let visible = initialVisible;

    // Hide all items initially
    items.forEach(item => item.style.display = 'none');

    // Show initial items
    for (let i = 0; i < visible && i < items.length; i++) {
      items[i].style.display = 'block';
    }

    // Hide button if not enough items
    if (items.length <= visible) loadMoreBtn.style.display = 'none';

    // Load more on button click
    loadMoreBtn.addEventListener('click', function () {
      const nextVisible = visible + increment;
      for (let i = visible; i < nextVisible && i < items.length; i++) {
        items[i].style.display = 'block';
      }
      visible = nextVisible;

      // Hide button if all items are shown
      if (visible >= items.length) loadMoreBtn.style.display = 'none';
    });
  }

  // Initialize for your dynamic wrapper
  initLoadMore('#dynamic', '.loadMore', 10, 10);

});


//collection







/* =====================================================
   YOUR CLEAR CART CODE (UNCHANGED)
===================================================== */


